/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclineTeamInviteResponse
 */
export interface DeclineTeamInviteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeclineTeamInviteResponse
     */
    success: boolean;
}

/**
 * Check if a given object implements the DeclineTeamInviteResponse interface.
 */
export function instanceOfDeclineTeamInviteResponse(value: object): value is DeclineTeamInviteResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function DeclineTeamInviteResponseFromJSON(json: any): DeclineTeamInviteResponse {
    return DeclineTeamInviteResponseFromJSONTyped(json, false);
}

export function DeclineTeamInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineTeamInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function DeclineTeamInviteResponseToJSON(json: any): DeclineTeamInviteResponse {
    return DeclineTeamInviteResponseToJSONTyped(json, false);
}

export function DeclineTeamInviteResponseToJSONTyped(value?: DeclineTeamInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

